/** Superficie pública de shared/supabase. */
export { bindSupabaseClient, isSupabaseJwtExpiredMessage, supabaseFetchWithAuthRetry } from './supabaseAuthSession';
export {
  ensureFreshAccessToken,
  refreshSupabaseSessionAndSyncStore,
  isSupabaseJwtExpiredError,
  supabase,
  getSupabaseConfig,
} from './supabaseClient';

export {
  classifyInvokeFailure,
  extractInvokeBodyError,
  messageFromInvoke,
  throwIfInvokeError,
  type InvokeErr,
  type InvokeErrorPayload,
  type InvokeFailureKind,
} from './invokeErrorUtils';
export {
  invokeEdgeOrPresent,
  type InvokeEdgeOrPresentResult,
  type InvokeEdgePresentContext,
} from './invokeEdgeOrPresent';

// Auto-added missing exports
export { isRealtimeMastersEnabled } from '../../sync/infra/realtimeMastersConfig';
